import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./index.css";

function renderFallback(message: string) {
  const root = document.getElementById("root");
  if (!root) return;
  root.innerHTML = `
    <div style="padding:24px;max-width:520px;margin:40px auto;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:#222;">
      <h1 style="font-size:24px;margin-bottom:12px;">BizDr could not load</h1>
      <p style="margin-bottom:12px;">${message}</p>
      <p>Please try refreshing the page, opening it in Chrome, or updating your phone browser.</p>
    </div>
  `;
}

try {
  const rootElement = document.getElementById("root");
  if (!rootElement) throw new Error("Root element not found");

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
} catch (error) {
  console.error("App boot error:", error);
  renderFallback("This device or browser may not support part of the app yet.");
}
